import {createClient} from '@propelauth/javascript';

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig().public;
  const e2eVisualTest = !!config.e2eVisualTest;
  if (e2eVisualTest) return; // Skip real auth when running E2E visual tests

  const authUrl = config.propelAuthUrl;

  const client = createClient({
    authUrl,
    enableBackgroundTokenRefresh: true,
  });

  client.addLoggedInChangeObserver(async isLoggedIn => {
    if (!isLoggedIn) {
      clearNuxtState(); // When the user logs out clear nuxt state

      if (nuxtApp.$posthog) {
        try {
          nuxtApp.$posthog().reset();
        } catch (error) {
          console.warn('Failed to reset PostHog on logout:', error);
        }
      }
    } else {
      try {
        const auth = await client.getAuthenticationInfoOrNull();

        if (!auth?.user) {
          return;
        }

        if (nuxtApp.$posthog) {
          nuxtApp.$posthog().identify(auth.user.userId, {
            email: auth.user.email,
            name: `${auth.user.firstName} ${auth.user.lastName}`,
            first_name: auth.user.firstName,
            last_name: auth.user.lastName,
            org_id: auth.orgHelper.getOrgs()[0].orgId,
            org_name: auth.orgHelper.getOrgs()[0].orgName,
          });
        }

        nuxtApp.$datadogRum().identifyUser(auth.user);
      } catch (error) {
        console.warn('Failed to identify user in PostHog on login:', error);
      }
    }
  });

  // Return the helper so it can be used in pages/components: const { $propelAuth } = useNuxtApp()
  return {
    provide: {
      propelAuth: client,
    },
  };
});
